"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const serviceConfigs_1 = require("@configs/serviceConfigs");
const callAPIRequest_1 = require("@service/callAPIRequest");
const urlUtils_1 = require("@utils/urlUtils");
class Common {
    /**
     * 取得模擬使用者資料
     *  @urlParam
     */
    static async searchUsers(data) {
        const parameters = (0, urlUtils_1.getUrlByParameters)(data);
        return await (0, callAPIRequest_1.httpRequest)({
            url: `${serviceConfigs_1.API_PREFIX}/${serviceConfigs_1.SERVICE_URL_CONFIG.DummyJSON.users}?${parameters}`,
            method: serviceConfigs_1.HTTP_METHOD.GET
        });
    }
}
exports.default = Common;
